module.exports = __webpack_public_path__ + "img/SKMJ_crain5.ca27a5a9.png";